import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Programs from "../components/Programs";

const Explorer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // ✅ Get "tab" from URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get("tab") || "Education"; // Default: "Education"

    // ✅ State to manage active tab
    const [activeTab, setActiveTab] = useState(tabFromUrl);

    // ✅ Update activeTab when URL changes
    useEffect(() => {
        setActiveTab(tabFromUrl);
    }, [location.search]); // Reacts to changes in query parameters

    const sidebarSections = [
        {
            title: "Programs",
            items: ["Education", "Enrollment", "Housing Programs", "Permits", "Social Services"],
        },
    ];

    // ✅ Handle sidebar tab clicks
    const handleTabChange = (item) => {
        navigate(`/explore?tab=${encodeURIComponent(item)}`); // Update URL when clicking sidebar
    };

    return (
        <div className="flex flex-col h-screen">
            {/* Header */}
            <div className="fixed top-0 left-0 w-full z-50 bg-primary">
                <Header />
            </div>

            {/* Main Layout */}
            <div className="flex flex-1 mt-[72px]">
                {/* Sidebar */}
                <div className="fixed left-0 w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
                    <Sidebar />
                </div>

                {/* Main Content */}
                <main className="flex-1 p-6 bg-gray-100 overflow-y-auto mt-[25px] lg:ml-64">
                    <Programs activeTab={activeTab} />
                </main>
            </div>
        </div>
    );
};

export default Explorer;
